import axios from "axios";
import { authHeader } from "./helpers/authHeader";

const Axios = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'https://delivery.fritabatatariaesaladeria.com.br/',
    timeout: 15000,
    headers: authHeader()
});

export default Axios;
